import MDP from "./MDP";

export default class FDrawerMDP implements MDP {
  componentName:string = "FDrawer";
  title?: string = "";
  childMDP: MDP;
  onClose:() => void;
  myRefName: string;
  isVisible: boolean;
  width?: string;

  constructor(props: {title?: string; childMDP: MDP;onClose:() => void;myRefName: string;isVisible: boolean;width?: string}) {
    this.title = props.title
    this.childMDP = props.childMDP;
    this.onClose = props.onClose;
    this.myRefName = props.myRefName;
    this.isVisible = props.isVisible;
    this.width = props.width
  }
  getMetaData(): object {
    return {
      componentName: this.componentName,
      myRefName: this.myRefName,
      props: {
        title: this.title,
        childMetaData: this.childMDP.getMetaData(),
        myRefName: this.myRefName,
        onClose: this.onClose,
        isVisible: this.isVisible,
        width: this.width
      }
    }
  }
}